import axios from 'axios';

// Create a separate axios instance for public requests (no authentication).
//
// baseURL was REACT_APP_API_URL (which is just the path segment "api") —
// fixed 2026-05-14 to REACT_APP_API_BASE_URL (the full backend origin) to
// match AxiosInstance.js. Pre-fix: callers that passed a RELATIVE URL
// instead of routing through getApiUrl() would resolve against window
// origin + "api/..." instead of the configured backend host. Latent
// because every existing caller passes an absolute getApiUrl(...) URL.
const publicAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 10000,
    withCredentials: false, // Important: don't send cookies
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add response interceptor for error handling (but no auth redirects)
publicAxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Log errors but don't redirect to login
        console.error('Public API Error:', error);
        return Promise.reject(error);
    }
);

export default publicAxiosInstance;